import { DOCUMENT } from '@angular/common';
import { inject, Inject, Injectable, signal, WritableSignal } from '@angular/core';

import { SsrService } from '@services/ssr.service';

declare var Cookies: any;
declare var google: any;
declare global {
  interface Window {
    googleTranslateElementInit: () => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleTranslateService {
  private ssrService = inject(SsrService);
  private webLanguage = 'cs';
  public activeLanguage: WritableSignal<string> = signal('cs');

  constructor(@Inject(DOCUMENT) private document: Document) { }

  initGoogleTranslator(): void {
    if (this.ssrService.isServer()) return;
    this.removeGoogleTranslator();
    const script = this.document.createElement('script');
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.onload = () => {
      window.googleTranslateElementInit = function () {
        new google.translate.TranslateElement({ pageLanguage: 'cs' }, 'google_translate_element');
      };
    };
    document.body.appendChild(script);
    this.document.body.appendChild(script);
  }

  removeGoogleTranslator(): void {
    if (this.ssrService.isServer()) return;
    const googleTranslateElement = this.document.querySelector('.goog-te-gadget');
    if (googleTranslateElement) {
      googleTranslateElement.remove();
    }
    const script = this.document.querySelector('script[src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]');
    if (script) script.remove();
  }

  setGoogleTranslator(language: string | null): void {
    if (this.ssrService.isServer() || !language) return;

    let domain: string | string[] = window.location.href;
    domain = domain.split('/')[2];
    domain = domain.split('.');
    if (domain.length > 1) {
      let domainSecond: string[] = domain[domain.length - 1].split(':');
      domain = '.' + domain[domain.length - 2] + '.' + domainSecond[0];
    } else {
      domain = domain[domain.length - 1];
    }

    this.activeLanguage.set(language);
    if (language === this.webLanguage) {
      this.initGoogleTranslator();
      this.document.location.hash = ``;
      Cookies.set('GoogleTranslator', null, { expires: 90, path: '/', domain: domain });
      this.document.location.reload();
    } else {
      this.initGoogleTranslator();
      this.document.location.hash = `googtrans(${this.webLanguage}|${language})`;
      Cookies.set('GoogleTranslator', language, { expires: 90, path: '/', domain: domain });
    }
  }

  handleHashLanguageInit(): void {
    if (this.ssrService.isServer()) return;
    const hash = this.document.location.hash;

    if (hash.includes('translate=')) {
      const lang = hash.substring(hash.indexOf('translate=') + 10, hash.indexOf('translate=') + 12);
      this.setGoogleTranslator(lang);
    } else if (hash.includes('googtrans')) {
      const lang = hash.substring(hash.indexOf('googtrans') + 15, hash.indexOf('googtrans') + 17);

      this.setGoogleTranslator(lang);
    } else {
      const cookieLang = Cookies.get('GoogleTranslator');
      if (cookieLang && cookieLang !== 'null') {

        this.initGoogleTranslator();
        this.setGoogleTranslator(cookieLang);
      }
    }
  }
}
